/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable complexity */
import { Injectable } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { NavigationConfig } from '@onboarding/models/navigation-config';

@Injectable({ providedIn: 'root' })
export class NavigationConfigService {
    public parse(configString: string): { route: RpcRoute; extras: NavigationExtras } | null {
        const parsed = this.tryParse(configString);

        if (parsed == null) {
            return null;
        }

        if (typeof parsed === 'string') {
            return {
                route: parsed as RpcRoute,
                extras: {},
            };
        }

        if (typeof parsed === 'object' && 'route' in parsed) {
            const config = parsed as NavigationConfig;
            const route = config.route as RpcRoute;
            const state = config.state ?? {};

            return {
                route,
                extras: { state },
            };
        }

        return null;
    }

    private tryParse(input: string): unknown {
        if (!input?.trim()) return null;

        const trimmed = input.trim();

        const isPlainString = /^[a-zA-Z0-9\-_]+$/.test(trimmed);

        if (isPlainString) return trimmed;

        try {
            const parsed = JSON.parse(input.trim());

            return parsed;
        } catch {
            return null;
        }
    }
}
